import React from 'react';
import PropTypes from 'prop-types';
import Textfit from 'react-textfit';
import { withProps } from 'recompose';
import Money from '../../../common/money';

const MoneyFit = ({ children, max, automationId }) => (
  <Textfit mode="single" max={max}>
    <Money automationId={automationId}>{children}</Money>
  </Textfit>
);

MoneyFit.propTypes = {
  children: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  automationId: PropTypes.string,
};

MoneyFit.defaultProps = {
  automationId: null,
};

export const MoneyFitLarge = withProps({
  max: 45,
})(MoneyFit);

export const MoneyFitMedium = withProps({
  max: 34,
})(MoneyFit);

export const MoneyFitSmall = withProps({
  max: 24,
})(MoneyFit);
